// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { BrowserUtils } from "../../Commons/UtilsClasses/BrowserUtils.js";
import { Resources, CurrentLang } from "../../Commons/properties/Resources.js";
import { TerceraBaseWindowTemplate, TerceraCreateDemoAccountScreenTemplate } from "../../templates.js";
import { TerceraButton } from "../elements/TerceraButton.js";
import { TerceraMessageBox } from "./TerceraMessageBox.js";
import { TerceraWindowBase } from "./TerceraWindowBase.js";


export let TerceraCreateDemoAccountScreen = TerceraWindowBase.extend({
    // template
    template: TerceraBaseWindowTemplate,
    data: function ()
    {
        return {
            movable: false,
            showFooter: false,
            resizable: false,
            //canSelect: false,
            alwaysMiddle: true,
            focused: true,

            btnRegisterStyle: TerceraButton.TerceraButtonStyle.Blue,
            btnCancelStyle: TerceraButton.TerceraButtonStyle.Standard,

            textLoginLabel: "Login:",
            textFirstNameLabel: "*First Name:",
            textLastNameLabel: "*Last Name:",
            textEmailLabel: "*Email:",
            textPhoneLabel: "Phone:",
            textCountryLabel: "Country:",
            textPasswordLabel: "*Password:",
            textConfirmLabel: "*Confirm:",
            textBalanceLabel: "Balance:",

            header: "Demo account registration",

            registerText: "Register",
            cancelText: "Cancel",
            btnRegisterNotBlocked: true,

            textLoginPlaceHolder: "<Leave empty for auto-generation>",
            textFirstNamePlaceHolder: "<min 2 chars>",
            textLastNamePlaceHolder: "<min 2 chars>",
            textEmailPlaceHolder: "<Email>",
            textPhonePlaceHolder: "<(country code) phone number>",
            textPasswordPlaceHolder: "<Password>",
            textConfirmPlaceHolder: "<Confirm password>",

            valueLogin: "",
            valueFirstName: "",
            valueLastName: "",
            valueEmail: "",
            valuePhone: "",
            valuePassword: "",
            valueConfirmPassword: "",
            countryComboItems: [],
            balanceComboItems: [],
            selectedCountryComboItems: null,
            selectedBalanceComboItems: null,
            valueEmailHaveError: true,

            connectionName: ""
        };
    },
    partials: { bodyPartial: TerceraCreateDemoAccountScreenTemplate }
});

TerceraCreateDemoAccountScreen.prototype.localize = function ()
{
    this.set({
        textLoginLabel: Resources.getResource('screen.registrationWizard.login'),
        textFirstNameLabel: Resources.getResource('screen.registrationWizard.firstName'),
        textLastNameLabel: Resources.getResource('screen.registrationWizard.lastName'),
        textEmailLabel: Resources.getResource('screen.registrationWizard.email'),
        textPhoneLabel: Resources.getResource('screen.registrationWizard.phone'),
        textCountryLabel: Resources.getResource('screen.registrationWizard.Country'),
        textPasswordLabel: Resources.getResource('screen.registrationWizard.Password'),
        textConfirmLabel: Resources.getResource('screen.registrationWizard.confirmPassword'),
        textBalanceLabel: Resources.getResource('screen.registrationWizard.Balance'),

        header: Resources.getResource('screen.registrationWizard.Header'),

        registerText: Resources.getResource('screen.registrationWizard.Register'),
        cancelText: Resources.getResource('screen.registrationWizard.Cancel'),

        textLoginPlaceHolder: Resources.getResource('screen.registrationWizard.login.watermark'),
        textFirstNamePlaceHolder: Resources.getResource('screen.registrationWizard.firstName.watermark'),
        textLastNamePlaceHolder: Resources.getResource('screen.registrationWizard.lastName.watermark'),
        textEmailPlaceHolder: Resources.getResource('screen.registrationWizard.email.watermark'),
        textPhonePlaceHolder: Resources.getResource('screen.registrationWizard.phoneNumber.watermark'),
        textPasswordPlaceHolder: Resources.getResource('screen.registrationWizard.password.watermark'),
        textConfirmPlaceHolder: Resources.getResource('screen.registrationWizard.confirmPassword.watermark')
    });
};

TerceraCreateDemoAccountScreen.prototype.oninit = function ()
{
    TerceraWindowBase.prototype.oninit.apply(this);

    this.on('cancelClick', this.close);
    this.on('registerClick', this.register);
    this.observe('valueEmail', function (newValue)
    {
        this.set({ valueEmailHaveError: !BrowserUtils.isEmail(newValue) });
    });

    this.observe('visible', function (visible)
    {
        if (visible) this.localize();
    });
    this.localize();
};

TerceraCreateDemoAccountScreen.prototype.oncomplete = function ()
{
    TerceraWindowBase.prototype.oncomplete.apply(this);

    this.populateCountries();
    this.populateBalance();
};

TerceraCreateDemoAccountScreen.prototype.populateCountries = function ()
{
    var items = [];
    items.push({ text: "Select country", value: -1 });
    var i;
    var len = TerceraCreateDemoAccountScreen.Countries.length;
    for (i = 0; i < len; i++)
    {
        items.push({ text: TerceraCreateDemoAccountScreen.Countries[i], value: TerceraCreateDemoAccountScreen.Countries[i] });
    }
    this.set({ countryComboItems: items });
};

TerceraCreateDemoAccountScreen.prototype.populateBalance = function ()
{
    var items = [];
    var i;
    var len = TerceraCreateDemoAccountScreen.BalanceValues.length;
    for (i = 0; i < len; i++)
    {
        items.push({ text: TerceraCreateDemoAccountScreen.BalanceValues[i], value: TerceraCreateDemoAccountScreen.BalanceValues[i] });
    }
    this.set({ balanceComboItems: items });
};

TerceraCreateDemoAccountScreen.prototype.createCallback = function (responce, isOk, newLogin, newPass)
{
    if (isOk)
    {
        let text = Resources.getResource('screen.registrationWizard.successMessage')
        let tArr = text.split('\n');
        var resText =
            tArr[0] + '<br>' +
            tArr[1].replace('{1}', newLogin) + '<br>' +
            tArr[1].replace('{2}', newPass);

        var callBack = this.close.bind(this);
        TerceraMessageBox.Show(
            Resources.getResource('screen.registrationWizard.registrationStatus'),
            resText,
            TerceraMessageBox.msgType.Info,
            callBack,
            null,
            false,
            true,
            null,
            {
                closeButtonCallBack: callBack,
                forceCloseOnLogout: false
            });
        //created #51199 ,commited #61057
        //this.off('registerClick', this.register);
    }
    else
    {
        TerceraMessageBox.Show(
            Resources.getResource('screen.registrationWizard.registrationStatus'),
            responce,
            TerceraMessageBox.msgType.Warning,
            null,
            null,
            false,
            true,
            null,
            { forceCloseOnLogout: false });

        // http://tp.pfsoft.net/entity/61479
        this.set('btnRegisterNotBlocked', true);
    }
};

TerceraCreateDemoAccountScreen.prototype.register = function ()
{
    //#51199 ,#61057
    this.set('btnRegisterNotBlocked', false);

    var dataMsg = {};

    dataMsg.locale = CurrentLang;
    dataMsg.login = this.get('valueLogin');
    dataMsg.firstName = this.get('valueFirstName');
    dataMsg.lastName = this.get('valueLastName');
    dataMsg.email = this.get('valueEmail');
    dataMsg.phone = this.get('valuePhone');
    dataMsg.country = this.get('selectedCountryComboItems').value;
    dataMsg.password = this.get('valuePassword');
    dataMsg.balnce = this.get('selectedBalanceComboItems').value;
    dataMsg.connectionName = this.get('connectionName');

    //TODO
    //App.Connection.vendor.createDemoAccount(dataMsg, this.createCallback.bind(this));
};


TerceraCreateDemoAccountScreen.BalanceValues = [
    1000,
    2000,
    5000,
    10000,
    20000,
    50000,
    100000];

TerceraCreateDemoAccountScreen.Countries = [];